export const PROGRESS = '[PROGRESS]'
export const ADD_TO_PROGRESS = `${PROGRESS} Progress in Story Mode`

export const addToProgress = progress => ({
    type: ADD_TO_PROGRESS,
    payload: {
        progress,
    },
    meta: {
        persisted: 'progression',
        checkProgress: 'true',
    },
})
